import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import { ForwardedRef } from 'react';

import AccountIcon from '../icons/AccountIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/account-button.module.css';

interface AccountButtonProps extends BasicButtonProps {
    color?: string;
    circleColor?: string;
}

function AccountButton({
    className = null,
    color = 'currentColor',
    circleColor = '#f5f5f5',
    ref: buttonRef = null,
    ...props
}: AccountButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    const user = useUser();

    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
        >
            <AccountIcon
                className={styles.icon}
                color={color}
                circleColor={circleColor}
                loggedIn={user !== null}
            />
        </BasicButton>
    );
}

export default AccountButton;
